/* 03 · THE SCREEN BLEEDS + 04 · NOW SHOWING — deferred.
   The ooze creeps down once; the title card burns in; posters light up ONE AT A TIME
   (staggered, even when a row enters together); ADD TO CART goes through Skeleton's NNCart. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = 'IntersectionObserver' in window;

  var drips = document.querySelectorAll('[data-nhp-drip]');
  var cards = document.querySelectorAll('[data-nhp-titlecard]');
  var posters = Array.prototype.slice.call(document.querySelectorAll('[data-nhp-poster]'));

  function once(el, threshold, fn, rootMargin) {
    new IntersectionObserver(function (entries, obs) {
      if (entries[0].isIntersecting) {
        fn();
        obs.disconnect();
      }
    }, { threshold: threshold, rootMargin: rootMargin || '0px' }).observe(el);
  }

  if (reduce || !io) {
    posters.forEach(function (p) { p.classList.add('is-lit'); });
  } else {
    // Watch the SECTION, not the drips: while waiting, the drips are clip-path'd to their top 14%,
    // and Chrome measures intersection through the clip — a threshold on the drip itself never fires.
    drips.forEach(function (d) {
      var section = d.closest('[data-nhp-ns]') || d.parentElement;
      d.classList.add('is-ready');
      once(section, 0, function () { d.classList.add('is-run'); }, '0px 0px -20% 0px');
    });

    cards.forEach(function (c) {
      c.classList.add('is-ready');
      once(c, 0.6, function () { c.classList.add('is-on'); });
    });

    // Light posters one by one: queue each as it hits 40% in view, release them 260ms apart.
    var queue = [];
    var timer = null;
    function release() {
      var next = queue.shift();
      if (!next) { timer = null; return; }
      next.classList.add('is-lit');
      timer = setTimeout(release, 260);
    }
    var lightObs = new IntersectionObserver(function (entries) {
      entries
        .filter(function (e) { return e.isIntersecting; })
        .sort(function (a, b) { return posters.indexOf(a.target) - posters.indexOf(b.target); })
        .forEach(function (e) {
          lightObs.unobserve(e.target);
          queue.push(e.target);
        });
      if (!timer) release();
    }, { threshold: 0.4 });
    posters.forEach(function (p) { lightObs.observe(p); });
  }

  /* THE REEL (<768px): which frame is centered → is-active + counter; arrows + arrow keys step a frame. */
  document.querySelectorAll('[data-nhp-reel]').forEach(function (reel) {
    var slides = Array.prototype.slice.call(reel.querySelectorAll('.nhp-ns__slide'));
    var wrap = reel.closest('.nhp-ns__inner') || reel.parentElement;
    var stage = wrap.querySelector('[data-nhp-stage]');
    var now = wrap.querySelector('[data-nhp-reel-now]');
    var total = wrap.querySelector('[data-nhp-reel-total]');
    var prev = wrap.querySelector('[data-nhp-reel-prev]');
    var next = wrap.querySelector('[data-nhp-reel-next]');
    if (!slides.length) return;
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var current = 0;
    if (total) total.textContent = pad(slides.length);

    function setActive(i) {
      if (stage && i !== current && !reduce) {
        stage.classList.remove('is-swap');
        void stage.offsetWidth;
        stage.classList.add('is-swap');
      }
      current = i;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      if (now) now.textContent = pad(i + 1);
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    }
    setActive(0);

    if (io) {
      var activeObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) setActive(slides.indexOf(e.target));
        });
      }, { root: reel, threshold: 0.6 });
      slides.forEach(function (s) { activeObs.observe(s); });
    }

    /* The light follows your finger: --beam is blended between the two nearest films' colors by exactly
       how far you've dragged (not snapped). Colors come from each poster's --glow. */
    function hexToRgb(h) {
      h = (h || '').trim().replace('#', '');
      if (h.length === 3) h = h.replace(/(.)/g, '$1$1');
      var n = parseInt(h, 16);
      return isNaN(n) ? [230, 51, 41] : [(n >> 16) & 255, (n >> 8) & 255, n & 255];
    }
    var colors = slides.map(function (s) {
      var poster = s.querySelector('[data-nhp-poster]');
      return hexToRgb(poster ? getComputedStyle(poster).getPropertyValue('--glow') : '');
    });
    var ticking = false;
    function paint() {
      ticking = false;
      if (!stage) return;
      var mid = reel.scrollLeft + reel.clientWidth / 2;
      var centres = slides.map(function (s) { return s.offsetLeft + s.offsetWidth / 2; });
      var i = 0;
      while (i < centres.length - 1 && centres[i + 1] <= mid) i++;
      var j = Math.min(i + 1, centres.length - 1);
      var t = j === i ? 0 : Math.max(0, Math.min(1, (mid - centres[i]) / (centres[j] - centres[i])));
      var a = colors[i], b = colors[j];
      stage.style.setProperty('--beam', 'rgb(' + Math.round(a[0] + (b[0] - a[0]) * t) + ',' + Math.round(a[1] + (b[1] - a[1]) * t) + ',' + Math.round(a[2] + (b[2] - a[2]) * t) + ')');
    }
    reel.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(paint); }
    }, { passive: true });
    paint();

    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      var s = slides[i];
      reel.scrollTo({ left: s.offsetLeft - (reel.clientWidth - s.clientWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    reel.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    });
  });

  /* PEEK INSIDE: one shared dialog; the stamp carries the video URL. */
  var peekDlg = document.querySelector('[data-nhp-peek-dialog]');
  var peekVid = peekDlg && peekDlg.querySelector('video');
  var peekFrom = null;
  if (peekDlg && peekDlg.showModal) {
    document.addEventListener('click', function (e) {
      var stamp = e.target.closest('[data-nhp-peek]');
      if (!stamp) return;
      peekFrom = stamp;
      peekVid.src = stamp.getAttribute('data-nhp-peek');
      peekDlg.showModal();
      if (!reduce) peekVid.play();
      else peekVid.setAttribute('controls', '');
    });
    peekDlg.querySelector('[data-nhp-peek-close]').addEventListener('click', function () { peekDlg.close(); });
    peekDlg.addEventListener('click', function (e) { if (e.target === peekDlg) peekDlg.close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && peekDlg.open) peekDlg.close(); });
    peekDlg.addEventListener('close', function () {
      peekVid.pause();
      peekVid.removeAttribute('src');
      peekVid.load();
      if (peekFrom) peekFrom.focus();
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nhp-add]');
    if (!btn || !window.NNCart) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'ADDING…';
    window.NNCart.addAndOpen(btn.getAttribute('data-nhp-add'), 1)
      .then(function () { btn.textContent = label; })
      .catch(function () { btn.textContent = 'TRY AGAIN'; })
      .then(function () { btn.disabled = false; });
  });
})();
